import { pick } from 'ramda';

import {
  CostCenterDetail,
  CostCenterDetailFlag,
  Flag,
  PlanUnit
} from '../../../types';
import { formatByLocale } from 'utils/date';

export const shouldHideSortOrder = (typeFieldValue: string) =>
  typeFieldValue === 'cc';

/**
 * Converts plan unit to form data
 */
export const apiToFormAdapter = (planUnit?: PlanUnit) => {
  if (!planUnit) {
    return {};
  }

  return {
    ...pick(
      [
        'brId',
        'type',
        'category',
        'privilegedEmailAddress',
        'sortOrderAgency',
        'colorCode'
      ],
      planUnit
    ),
    REQUEST_EXCLUDE: planUnit.flags
      ? planUnit.flags.includes(Flag.REQUEST_EXCLUDE)
      : false
  };
};

/**
 * Maps formFlags for to API
 *
 * Ie.: flags: {
 *     FLAG_1: true,
 *     FLAG_2: false
 * } => [FLAG_1]
 */
export const mapFormFlagsForApi = (formFlagsData) => {
  const flagsArr: CostCenterDetailFlag[] = [];
  for (const flag in formFlagsData) {
    if (formFlagsData[flag]) {
      flagsArr.push(CostCenterDetailFlag[flag]);
    }
  }

  return flagsArr;
};

/**
 * Converts form data for API (planUnit)
 */
export const formToApiAdapterBase = (planUnitFormData) => ({
  ...pick(
    [
      'brId',
      'type',
      'category',
      'privilegedEmailAddress',
      'sortOrderAgency',
      'colorCode',
      'REQUEST_EXCLUDE'
    ],
    planUnitFormData
  ),
  flags: [...(planUnitFormData.REQUEST_EXCLUDE ? [Flag.REQUEST_EXCLUDE] : [])]
});

/**
 * Converts form data for API (planUnit details)
 */
export const formToApiAdapter = (planUnitFormData) => {
  return {
    ...formToApiAdapterBase(planUnitFormData),
    details: {
      ...pick(
        [
          'code',
          'name',
          'nameShort',
          'codeExt',
          'codeExtSecondary',
          'codeImp',
          'codeImpSecondary',
          'benefitStartDate',
          'valid',
          'flags',
          'employerId'
        ],
        planUnitFormData
      ),
      flags: mapFormFlagsForApi(planUnitFormData.flags),
      finBrDynId: planUnitFormData.finBrDynId.value,
      parentBrDynId: planUnitFormData.parentBrDynId.value
    }
  };
};

export const formatCostCenterDetailLabel = (
  item: CostCenterDetail,
  labelKey?: string
) => {
  const name = item[labelKey ?? ''] || item.name || item.nameShort;
  const validity = `(${formatByLocale(
    new Date(item.valid.from)
  )} - ${formatByLocale(new Date(item.valid.to))})`;
  return `${name} ${validity}`;
};
